<!-- 常见问题 -->
<template>
  <div class="">
    <headerBar/>
    <div class="ysc_banner">
      <div class="c_banner_txt wow fadeInDown">
        <div class="c_banner_tit">感谢您选择京东智慧供应链开放平台</div>
        <div class="c_banner_subTit">在使用过程中有任何疑问请随时联系客服</div>
      </div>
    </div>
    <Layout class="ysc_index_content">
      <Sider hide-trigger :style="{background: '#f9f9f9'}">
        <Menu active-name="sfs" width="auto" :style="{background: '#f9f9f9', textAlign: 'center'}"
          @on-select="menuSelect">
          <MenuItem :name="side.name" v-for="side in questionsData" :key="side.name">{{side.nameTxt}}</MenuItem>
        </Menu>
      </Sider>
      <Content v-for="row in questionsData" :key="row.name" v-if="menuActive == row.name">
        <Collapse v-model="collapseName" :accordion="true">
          <Panel :name="collapsedData.name + '_' + index" v-for="(question, index) in collapsedData.content" :key="index">
            {{question.name}}
            <div v-html="question.text" slot="content"></div>
          </Panel>
        </Collapse>
      </Content>
    </Layout>
    <footerBar/>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import unsale1Pic from '@/assets/images/unsale1.png'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    headerBar: () => import("../components/headerBar/HeaderBar.vue"),
    footerBar: () => import("../components/footer/Footer.vue")
  },
  data() {
    //这里存放数据
    return {
      menuActive: 'sfs',
      collapseName: 'sfs_0',
      collapsedData: null,
      questionsData: [
        {
          name: 'sfs',
          nameTxt: '销量计划',
          content: [
            {
              active: true,
              name: '1、输入销售额计划的作用是什么？',
              text: '答：用户可输入未来3个月的销售额计划，单位是元，输入后可在销售概况图上展示出计划值，可直观比对出计划历史销售及未来销售预测的差异，输入计划后系统可自动计算完成率并在图上进行展示。',
            },
            {
              active: false,
              name: '2、哪里可以查看历史销售情况？',
              text: '答：销售概况，此处可在事业部维度上对销售情况进行整体的展示和评估，可展示的字段为：历史销量，历史销售额，历史库存量，历史库存金额，销量预测，销售额预测，销售计划（商家输入才可显示），销售计划完成率（商家输入才可显示），环比>30%'
            },
            {
              active: false,
              name: '3、销售预测是如何预测的？',
              text: '答：销售预测是对京东历史大数据进行清洗（如季节调整，极值平滑等），再应用多种模型进行计算，拟合PK确保结果最优后进行输出。商品所用到的预测模型重点考虑因素可以在预测模型说明中进行查看。',
            },
            {
              active: false,
              name: '4、可否沿用我自己的预测方式，不使用系统模型？',
              text: `答：可以，为方便习惯使用自己现有预测方式的用户，系统提供了两种预测方式，
              方案一是系统预测，方案二是用户自定义预测，可在预测模型设置中可进行修改，
              销量预测 = （历史销量数值1X系数1+历史销量数值2X系数2） X 系数3，其中历史
              销量数值1和2为可选项，用户可选择使用历史7/14/28天平均销量，系统1,2,3为用户输入项\
              `,
            },
            {
              active: false,
              name: '5、历史销量和预测销量是否可下载',
              text: '答：可以下载，下载路径1：销售概况-商品销售排行榜-下载，下载路径2：销售预测分析图-当前查询数据下载/全部数据下载',
            }
          ],
        },
        {
          name: 'pbs',
          nameTxt: '智能补货',
          content: [
            {
              active: true,
              name: '1、预测补货输出补货建议的原理是什么？',
              text: '答：预测补货基于京东预测技术输出商品预测销量，通过补货参数设置进行计算目标库存量（商家可能称为为备货量、补至多少周转天数），考虑商家现有库存量、采购在途等输出补货建议量。',
            },
            {
              active: false,
              name: '2、分仓补货输出补货建议的原理是什么？',
              text: '答：分仓补货按照商家所选择的分仓类型，依旧商家总补货量为商家提供按照预测（或历史）销量比例进行分仓，或按照预测（或历史销量）平衡各仓周转天数进行进行分仓，同样考虑商家现有库存量、采购在途量。'
            },
            {
              active: false,
              name: '3、补货建议量和最终补货量有什么区别？',
              text: '答：补货建议量是按照系统通过计算输出的建议补货量，最终补货量默认等于建议补货量，商家可以根据自己的实际情况进行修改。',
            },
            {
              active: false,
              name: '4、补货参数是否需要进行维护？',
              text: '答：补货参数中库存水位参数系统提供默认值进行计算，其他补货参数默认都是没有设置的，建议商家清晰每个补货参数的含义和作用，最好试用一阶段后商家可依据商家的实际需求和情况进行设置。',
            },
            {
              active: false,
              name: '5、补货运算的频率是怎么样的？',
              text: '答：预测补货的运算频率是每天凌晨系统会运算一次，商家可以手动发起实时重算；分仓补货的运算频率是商家上传触发补货运算。两种补货方式商家可以根据',
            },
            {
              active: false,
              name: '6、库存水位设置参数具体是如何作用的？商家如何自己维护？',
              text: `
              答：安全库存（天数或量）：当库存小于安全库存时触发补货动作
              目标库存：库存管理日常中备货的目标
              补货量=目标库存量-库存-采购在途量
              商家自己维护安全库存设置建议大于送货时长和下单周期（天数），因为如果小于送货时长和下单周期可能会存在断货风险。
              商家自己维护目标库存设置商家建议根据自己实际备货的的需求，期望补货后达到的目标库存。
              三个维度的设置优先级高低为：EMG维度>品类维度>事业部维度，即优先级高的设置维度设置后优先生效
              `,
            }
          ],
        },
        {
          name: 'vrs',
          nameTxt: '滞销处理',
          content: [
            {
              active: true,
              name: '1、滞销商品筛选的规则有哪些？',
              text: '商品分为高周转、周转预警、无销售、残品、效期锁定品，不同类型的商品，会有不同的处理建议。',
            },
            {
              active: false,
              name: '2、高周转与周转预警区别是什么？',
              text: `<p>高周转是系统自动计算出来的，高周转>平均周转,</p><p><img src="`+ unsale1Pic +`" alt="" /></p><p>周转预警是用户在参数设置中配置的，即“预警周转天数是N天（滞销周转阀值）</p>`,
            },
            {
              active: false,
              name: '3、筛选无销售时出现的商品是指单仓还是全国？',
              text: '选择某个仓，点击无销售显示是该仓单仓无销售商品',
            },
            {
              active: false,
              name: '4、严重无销售、普通无销售作用是什么？',
              text: '全国无销售是用于计算不同级别无销售时建议退货量的',
            },
            {
              active: false,
              name: '5、建议处理量是如何计算的？',
              text: '<p>建议量=库存-目标库存；（例：库存151，目标库存100，建议量=51）</p><p>目标库存=销量*目标周转（平均周转）</p><p><img src="'+ unsale1Pic +'" alt=""></p><p>销量取值：max（28,120日均历史销量）</p>',
            },
          ]
        },
        {
          name: 'ihs',
          nameTxt: '库存健康',
          content: [
            {
              active: true,
              name: '1、智慧供应链里的“件数周转“和入仓商品”超90天周转“计费里的周转差异在哪里？',
              text: `答：两者计算口径不同 1）件数周转=库存/历史28天日均出库量（每天滚动计算，可自定义）2）
                      仓储周转=月度每天库存之和/月度每天出库量之和（每月计算一次）
                      在库存健康-库存看板里两个周转均存在。`,
            },
            {
              active: false,
              name: '2、进销存数据哪里可以下载？都涵盖哪些字段？',
              text: '答：有两个路径，1）库存告警页面下对应预警需求的数据；2）报表中心选择所需报表，并到任务中心进行下载。'
            },
            {
              active: false,
              name: '3、库存规则中的设置数据项较多，如何快速设置我所需的预警水位？',
              text: '答：在库存预警页面的设置可支持全量EMG的阈值设置，库存不足的默认规则是周转低于15天，滞销的默认规则是周转大于90天，自定义修改后的设置次日生效。',
            },
            {
              active: false,
              name: '4、库存预警看板里的明细数据是否可以下载？',
              text: `答：1）库存预警中不足、滞销、不动销页面均有数据下载按钮，可下载所需的明细，如需全量库存数据，也可到报表中心进行下载。
              `,
            },
            {
              active: false,
              name: '5、库存健康中各指标的公式及默认规则是怎么样的？',
              text: `
                <table class="ivu-table ivu-table-default">
                  <thead>
                      <tr>
                        <th width="20%">指标名称</th>
                        <th width="40%">默认公式</th>
                        <th width="40%">变量修改(T+1)</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                        <td>组件周转</td>
                        <td>现货库存/历史28天日均出库量</td>
                        <td>
                            <p>库存口径：ERP库存/可用库存；</p>
                            <p>周转基于销量：*日均销量（默认28天）</p>
                            <p>销量为0，赋值0.1</p>
                        </td>
                      </tr>
                      <tr>
                          <td>仓储周转</td>
                          <td>自然月每天始点库存件数数量总和/自然月每天销售出库件数数量总和</td>
                          <td>无</td>
                      </tr>
                      <tr>
                          <td>实物现货率</td>
                          <td>1-缺货率 近30天货品缺货（始点库存为0）天数*仓/总在仓天数*仓
                          </td>
                          <td>无</td>
                      </tr>
                      <tr>
                          <td>跨区占比</td>
                          <td>近30天始发库房和到货地判定为非一区的订单数/商家总订单数</td>
                          <td>无</td>
                      </tr>
                      <tr>
                          <td>滞销占比</td>
                          <td>
                              <p>
                                  滞销库存/总库存</p>
                              <p>滞销库存=库存-日均销量*滞销阈值，如果日均销量为0，则保留最低保有量</p>
                              <p>按照每个库房进行计算，汇总到全国</p>
                          </td>
                          <td>
                              <p>滞销阈值：默认90天；</p>
                              <p>无销售基本备货：默认1个</p>
                          </td>
                      </tr>
                      <tr>
                          <td>不动销占比</td>
                          <td>
                              <p>
                                  不动销库存/总库存</p>
                              <p>按照每个库房进行计算，汇总到全国</p>

                          </td>
                          <td>
                              <p>总参与计算范围：连续*日有货（默认昨日有货即参与计算） 不动销阈值：*日无销量（默认28天）； 无销售基本备货：默认1个
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>动销率</td>
                          <td>
                              <p>
                                  有销售EMG个数/总EMG数 按照全国和库房分别进行计算
                              </p>

                          </td>
                          <td>
                              无
                          </td>
                      </tr>
                      <tr>
                          <td>BAND</td>
                          <td>
                              <p>
                                  A-band：全国出库量和前80%的EMG；
                              </p>
                              <p>B-band：全国出库量和后20%的EMG；</p>
                              <p>C-band：全国出库量为0的EMG；</p>
                          </td>
                          <td>
                              无
                          </td>
                      </tr>
                      <tr>
                          <td>库存可售天数</td>
                          <td>
                              ERP库存/可用库存
                          </td>
                          <td>
                              可售天数基于销量：*日均销量（默认28天）
                          </td>
                      </tr>
                      <tr>
                          <td>库存不足</td>
                          <td>
                              可售天数低于15天的EMG
                          </td>
                          <td>
                              <p>可售天数基于销量：*日均销量（默认28天）</p>
                              <p>可售天数低于*天（默认15天）</p>
                          </td>
                      </tr>
                  </tbody>
                </table>
              `,
            }
          ]
        },
        {
          name: 'il',
          nameTxt: '存货布局',
          content: [
            {
              active: true,
              name: '1、什么是发货地口径和收货地口径？',
              text: '答：发货地口径是指按照发货库房所属区域汇总；收货地口径是指按照出库单上客户三级收货地址所属区域汇总，依据仓储覆盖关系优先级还原最优发货库房。',
            },
            {
              active: false,
              name: '2、次日达覆盖率是如何计算？',
              text: '答：次日达覆盖率：上一自然月出库订单中，始发库房至到货目的地依据EMG销量统计符合次日达的出库量除以及总出库量',
            },
            {
              active: false,
              name: '3、单均重量为何为空？',
              text: '答：经分析数据质量，目前仅有约1/3的EMG能够取到重量数据，当商家动销EMG重量数据维护比例不足90%以上到时，默认展示为空，需要手工维护单均重量。',
            },
            {
              active: false,
              name: '4、爆品分析中的爆品是如何定义的？',
              text: `答：通过分析销量占比曲线，锁定销量占比拐点的商品，并分析商品销量的连续稳定情况，为商家推荐具体建议入仓的商品。`,
            }
          ]
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    menuSelect (name) {
      // console.log(name)
      this.menuActive = name
      this.collapsedData = this.questionsData.find((item, i) => item.name === name)
      this.collapseName = this.collapsedData && this.collapsedData.name + '_0'
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.collapsedData = this.questionsData[0]
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../assets/scss/yscIndex";
@import "../../../assets/muss/muss";

.ysc_banner {
  background: #000 url('../../../assets/images/tbg3.png') top center no-repeat;
  background-size: cover;
}
</style>
<style lang="scss">
.ysc_index_content{
  .ivu-collapse-content-box {
    line-height: 30px;
  }
  .ivu-collapse-header{
    background-color: #ffffff;
  }
  .ivu-table{
    border: 1px solid #eee;
    border-bottom: 0;
    border-spacing: 0;
    &::before,
    &::after{
      display: none;
    }
    th{
      font-weight: bold;
    }
    td,th{
      padding: 5px 10px;
      height: auto;
      font-size: 14px;
    }
    td + td, th + th {
      border-left: 1px solid #eee;
    }
  }
}
</style>
